export default "__VITE_ASSET__CmV991rT__"